export enum EnumStatusMovimentacaoEstoque {
    RESERVAR = 0,
    DESRESERVAR = 1,
    APROVAR = 2,
    ESTORNAR = 3
}